import { useEffect } from 'react';

// @ts-expect-error - no TypeScript definitions yet
import { useCurrentUser } from 'src/store';

/**
 * Publishes the current user to the Zoho SalesIQ widget.
 *
 * The widget loads via GTM in plain page scope and can't read React state, so we
 * expose the identity on `window.zohoVisitor` for its `ready` callback to consume.
 * If the widget already finished loading before the user resolved, `ready` has
 * already fired — so we also set the visitor directly here to cover that ordering.
 */
export const ZohoVisitorUpdater = () => {
  const currentUser = useCurrentUser();

  useEffect(() => {
    if (!currentUser) {
      return;
    }

    window.zohoVisitor = { email: currentUser.email };

    if (window.$zoho?.salesiq?.visitor) {
      window.$zoho.salesiq.visitor.email(currentUser.email);
    }
  }, [currentUser]);

  return null;
};
